import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import { Provider } from 'react-redux';
import Cookies from 'js-cookie';
import moment from 'moment';
import {
  setActiveLanguage, LocalizeProvider
} from 'react-localize-redux';

import Main from './components/Main';
import { getCurrentUserAction } from './actions';
import {
  AVAILABLE_LANGUAGES,
  LANG_COOKIE_NAME,
  SENTRY_TRACKED_HEADERS
} from './constants';
import createStore from './store';
import envConfig from './constants/env';

import './styles/global';
import MatomoTracker from './components/Matomo/MatomoTracker';

const cookieLang = Cookies.get(LANG_COOKIE_NAME);
const store = createStore();

const render = (Component) => {
  ReactDOM.render(
    <Provider store={store}>
      <LocalizeProvider store={store}>
        {
          envConfig.MATOMO_ENABLED && <MatomoTracker siteId={envConfig.MATOMO_SITE_ID} />
        }
        <Component />
      </LocalizeProvider>
    </Provider>,
    document.getElementById('root')
  );
};

const setLanguage = (userPreferredLanguage) => {
  const activeLang = cookieLang || userPreferredLanguage || AVAILABLE_LANGUAGES[0];
  document.documentElement.lang = activeLang;
  store.dispatch(setActiveLanguage(activeLang));
  moment.locale(activeLang);
};

if (envConfig.SENTRY_ENABLED) {
  Sentry.init({
    dsn: envConfig.SENTRY_DSN,
    environment: envConfig.SENTRY_ENVIRONMENT,
    release: `unihow-frontend@${process.env.COMMIT_HASH}`,
    // Off by default before v6. Session envelopes bypass beforeSend, so keep them disabled.
    autoSessionTracking: false,
    beforeSend(event) {
      delete event.user;
      delete event.request.cookies;
      Object.keys(event.request.headers).forEach((key) => {
        if (!SENTRY_TRACKED_HEADERS.includes(key)) {
          delete event.request.headers[key];
        }
      });

      return event;
    }
  });
}

store.dispatch(getCurrentUserAction())
  .then((user) => {
    setLanguage(user.value.preferredLanguage);
  })
  .catch(() => setLanguage())
  .then(() => render(Main));
